import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-medium text-navy mb-3">{title}</h2>
    <div className="space-y-3 text-base leading-relaxed text-slate-600">{children}</div>
  </div>
);

const Terms = () => (
  <div data-testid="terms-page">
    <PageHero overline="Legal" title="Terms of Use" />
    <section className="bg-white">
      <div className="mx-auto max-w-3xl px-6 sm:px-8 lg:px-12 py-24 sm:py-28">
        <p className="text-sm text-slate-500 mb-12">Last updated: {new Date().getFullYear()}</p>

        <Section title="Website Use">
          <p>
            By accessing this website, you agree to use it for lawful purposes and in a manner that does
            not infringe the rights of, or restrict the use of, this site by any third party.
          </p>
        </Section>
        <Section title="SMS Messaging Terms">
          <p>
            By opting in, you agree to receive SMS text messages from Yana Capital Group related to
            consultation scheduling and follow-ups on your inquiries.
          </p>
          <p>
            Message frequency varies. Message and data rates may apply. Reply <strong>HELP</strong> for
            help or <strong>STOP</strong> to opt out at any time. Carriers are not liable for delayed or
            undelivered messages.
          </p>
          <p>
            For details on how we handle your mobile information, see our{" "}
            <Link to="/privacy" className="text-gold hover:underline">Privacy Policy</Link>.
          </p>
        </Section>
        <Section title="No Professional or Legal Guarantee">
          <p>
            Content on this website is provided for general informational purposes only and does not
            constitute professional, legal, financial, or compliance advice. No engagement or advisory
            relationship is formed by use of this website alone.
          </p>
        </Section>
        <Section title="Intellectual Property">
          <p>
            All content, branding, and materials on this site are the property of Yana Capital Group and
            may not be reproduced or distributed without prior written consent.
          </p>
        </Section>
        <Section title="Limitation of Liability">
          <p>
            Yana Capital Group shall not be liable for any direct, indirect, or consequential loss
            arising from the use of, or reliance on, information presented on this website.
          </p>
        </Section>
        <Section title="Contact">
          <p>
            Questions about these terms can be directed to{" "}
            <a href="mailto:ScottWilson@yanacapitalgroup.com" className="text-gold hover:underline">
              ScottWilson@yanacapitalgroup.com
            </a>.
          </p>
        </Section>
      </div>
    </section>
  </div>
);

export default Terms;
